import clsx from "clsx";
import React from "react";
import { HorizontalAlignment, MediaSpecific, VerticalAlignment, mediaSpecificClassSWL } from "../Layout";
import styles from "./card.module.scss";

export const enum CardImagePosition
{
    Bottom,
    Left,
    Right,
    Top
}

export const enum HeroCardImageAlignment
{
    Top,
    Center,
    Bottom,
    Full
}

export const enum HeroCardImageSize
{
    Large,
    Medium,
    Small
}

interface CardImageLayout
{
    position?: CardImagePosition;
    verticalAlignment?: VerticalAlignment | null;
    horizontalAlignment?: HorizontalAlignment | null;
}

interface CardImageProps extends React.ComponentProps<"figure">
{
    layout?: MediaSpecific<CardImageLayout>;
}

export const CardImage = ({ className, layout, ...props }: CardImageProps): React.ReactComponentElement<"figure", CardImageProps> =>
{
    const classes = clsx(
        styles["image"],
        mediaSpecificClassSWL("bottom", layout, "position", CardImagePosition.Bottom, c => styles[c]),
        mediaSpecificClassSWL("left", layout, "position", CardImagePosition.Left, c => styles[c]),
        mediaSpecificClassSWL("right", layout, "position", CardImagePosition.Right, c => styles[c]),
        mediaSpecificClassSWL("top", layout, "position", CardImagePosition.Top, c => styles[c]),
        mediaSpecificClassSWL("h-left", layout, "horizontalAlignment", HorizontalAlignment.Left, c => styles[c]),
        mediaSpecificClassSWL("h-center", layout, "horizontalAlignment", HorizontalAlignment.Center, c => styles[c]),
        mediaSpecificClassSWL("h-right", layout, "horizontalAlignment", HorizontalAlignment.Right, c => styles[c]),
        mediaSpecificClassSWL("h-unset", layout, "horizontalAlignment", null, c => styles[c]),
        mediaSpecificClassSWL("v-top", layout, "verticalAlignment", VerticalAlignment.Top, c => styles[c]),
        mediaSpecificClassSWL("v-center", layout, "verticalAlignment", VerticalAlignment.Center, c => styles[c]),
        mediaSpecificClassSWL("v-bottom", layout, "verticalAlignment", VerticalAlignment.Bottom, c => styles[c]),
        mediaSpecificClassSWL("v-unset", layout, "verticalAlignment", null, c => styles[c]),
        className,
    );

    return <figure {...props} className={classes} />;
}